import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import { useBodyBackgroundColor } from 'Hooks/useBodyBackgroundColor';
import { FDContentContainer } from '@facet-wealth/design';
import { NavButtonsContextProvider } from '../NavButtonsContext';

const useStyles = buildUseStyles('TopNav', (theme) => ({
  root: {
    // There are other places in the app where <AppBar> is used on the page, and those <AppBar>s should not cover up this one.
    // For example, if you fail CIP you'll see an <AppBar> with the regular zIndex, and if you scroll down it will cover up this one
    zIndex: theme.zIndex.appBar + 1,
  },
  toolbar: {
    alignItems: 'stretch',
    justifyContent: 'space-between',
    paddingLeft: 0,
    paddingRight: 0,
    '& > :first-child > :first-child': {
      marginLeft: -theme.spacing(2),
    },
    '& > :last-child > :last-child': {
      marginRight: -theme.spacing(2),
    },
  },
}));

const Index = ({ Component }) => {
  const classes = useStyles();

  const bodyBackgroundColor = useBodyBackgroundColor();

  return (
    <AppBar position="sticky" elevation={0} className={classes.root} style={{ background: bodyBackgroundColor }}>
      <FDContentContainer maxWidth="xl">
        <Toolbar className={classes.toolbar}>
          <NavButtonsContextProvider>
            <Component />
          </NavButtonsContextProvider>
        </Toolbar>
      </FDContentContainer>
    </AppBar>
  );
};

Index.propTypes = {
  Component: PropTypes.func.isRequired,
};

export default Index;
